/**
 * @fileoverview フッター
 */

import { useState } from "react";
import { useTranslation } from "react-i18next";
import LicenceModal from "./LicenceModal";

/**
 * フッター
 * @returns {JSX.Element} フッターのJSX要素
 */
export function Footer(): JSX.Element {
  const { t } = useTranslation();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <footer className="p-footer">
      <div className="p-footer__copyrights">
        <div className="p-footer__copyrights-inner">
          <div className="p-footer__logo">
            <img
              src={"/asset/img/common/lgo_gst_square.jpg"}
              alt={t("株式会社ガステック")}
            ></img>
          </div>
          <div className="p-footer__copyrights">
            <a href="#" onClick={() => openModal()}>
              {t("OSS Licence")}
            </a>
            <br />
            Copyright&copy; GASTEC CORPORATION. Rights Reserved.
          </div>
        </div>
      </div>
      <LicenceModal isOpen={isModalOpen} onClose={closeModal} />
    </footer>
  );
}
